module.exports = __webpack_public_path__ + "static/sport/bgi-btn.cfdb00c.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Ldp/bgi-btn.gif
// module id = XyNC
// module chunks = 0